import { createSlice } from "@reduxjs/toolkit";
import { getAccountDetails, getProfile } from "./thunkActions";

export type AccountStatus = "idle" | "loading" | "ready" | "error";

interface InitialState {
  isLoading: boolean;
  isUpdatingPassword: boolean;
  accountStatus: AccountStatus;
  profile: IProfile | null;
  accountDetails: IAccountDetails | null;
}

const initialState: InitialState = {
  isLoading: false,
  accountStatus: "idle",
  isUpdatingPassword: false,
  profile: null,
  accountDetails: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.profile = null;
        state.isLoading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.isLoading = false;
      })
      .addCase(getProfile.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getAccountDetails.pending, (state) => {
        state.accountStatus = "loading";
      })
      .addCase(getAccountDetails.fulfilled, (state, action) => {
        state.accountDetails = action.payload;
        state.accountStatus = "ready";
      })
      .addCase(getAccountDetails.rejected, (state) => {
        state.accountStatus = state.accountDetails ? "ready" : "error";
      })
  },
});

export default profileSlice.reducer;
export * from "./thunkActions";
